import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ArabicIcon from '../Common/icons/ArabicIcon';
import EnglishIcon from '../Common/icons/EnglishIcon';
import LanguageSelect from './LanguageSelect';

const LanguageSwitcher = (props) => {
  const { sitecoreContext } = props;
  const link = `${sitecoreContext.language === 'en' ? '/ar' : '/en'}${sitecoreContext.itemPath}`;
  // console.log('sitecoreContext', sitecoreContext)
  const getClassName = () => {
    return props?.mode?.HeaderInDarkColor === '1' || props?.dark ? 'fill-black-300 hover:fill-red-500' : 'fill-white text-white stroke-white hover:fill-[#C4C7C9]';
  };

  if (typeof document !== 'undefined') {
    document.documentElement.lang = sitecoreContext?.language;
  }
  // console.log('props.homePage', props.homePage)
  const langs = sitecoreContext.Itemlanguages?.[0] ?? [];
  if (langs.length > 2 && props.homePage) {
    return <LanguageSelect options={sitecoreContext.Itemlanguages[0]} currntLanguage={sitecoreContext.language} className={getClassName()}></LanguageSelect>;
  } else {
    return (
      <a href={link}>
        {sitecoreContext.language === 'en' ? (
          <ArabicIcon className={getClassName() + ' 2xl:h-[26px] xl:h-[26px] lg:h-[21px] h-[18px]'} />
        ) : (
          <EnglishIcon className={getClassName() + ' 2xl:h-[26px] xl:h-[26px] lg:h-[21px] h-[18px]'} />
        )}
      </a>
    );
  }
};

export default withSitecoreContext()(LanguageSwitcher);

